import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/lib/i18n';
import { ArrowLeft } from 'lucide-react';

export default function ImprintPage() {
  const { language } = useLanguage();
  const nav = useNavigate();
  const de = language === 'de';

  return (
    <div className="min-h-screen bg-bone" data-testid="imprint-page">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <button onClick={() => nav('/')} className="flex items-center gap-2 text-foreground/60 hover:text-foreground mb-8 font-body text-sm transition-colors">
          <ArrowLeft size={16} /> <span className="font-display text-xl font-semibold"><span className="text-terracotta">bel</span>osophie</span>
        </button>

        <h1 className="font-display text-3xl md:text-4xl font-medium mb-8">{de ? 'Impressum' : 'Imprint'}</h1>

        <div className="space-y-6 font-body text-sm text-foreground/70 leading-relaxed">
          <section>
            <h2 className="font-display text-lg font-medium text-foreground mb-2">{de ? 'Angaben gemaess Art. 5 DSG / DSGVO' : 'Information according to GDPR'}</h2>
            <p>belosophie<br/>Belinda<br/>{de ? 'Schweiz' : 'Switzerland'}</p>
          </section>
          <section>
            <h2 className="font-display text-lg font-medium text-foreground mb-2">{de ? 'Kontakt' : 'Contact'}</h2>
            <p>E-Mail: info@belosophie.com</p>
          </section>
          <section>
            <h2 className="font-display text-lg font-medium text-foreground mb-2">{de ? 'Haftungsausschluss' : 'Disclaimer'}</h2>
            <p>{de
              ? 'belosophie ist eine Wellness- und Lifestyle-App und kein Medizinprodukt. Die bereitgestellten Inhalte dienen ausschliesslich Informationszwecken und ersetzen keine professionelle medizinische Beratung, Diagnose oder Behandlung.'
              : 'belosophie is a wellness and lifestyle app, not a medical device. The content provided is for informational purposes only and does not replace professional medical advice, diagnosis or treatment.'}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
